export const CLIENT_NOT_CREATED = 'CLASSROOM/CLIENT_NOT_CREATED'
export const MICRO_OR_VIDEO_NOT_INITIALIZED =
    '@CLASSROOM/MICRO_OR_VIDEO_NOT_INITIALIZED'
export const AUDIO_NOT_FOUND = '@CLASSROOM/AUDIO_NOT_FOUND'
export const VIDEO_NOT_FOUND = '@CLASSROOM/VIDEO_NOT_FOUND'
